import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CircularProgress from '@mui/material/CircularProgress';


function AddtionalOrderIndex() {

    const { id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [deleteItemName, setDeleteItemName] = useState('');
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchAddtionals();
    }, [isAuthenticated, companyId, token, logout]);

    const fetchAddtionals = async () => {
        try {
            setLoading(true);
            const response = await fetchData('AdditionalOrderIndex', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching order details:', error);
        } finally {
            setLoading(false);
        }
    };

    const openDeleteDialog = (itemId, itemName) => {
        setDeleteItemId(itemId);
        setDeleteItemName(itemName);
        setConfirmDialogOpen(true);
    };

    const closeDeleteDialog = () => {
        setDeleteItemId(null);
        setDeleteItemName('');
        setConfirmDialogOpen(false);
    };

    const handleDelete = async () => {
        deleteData('AdditionalOrderEditAPI', `${deleteItemId}`, token)
            .then(() => {
                fetchAddtionals();
                closeDeleteDialog();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
                closeDeleteDialog();
            });
    };

    return (
        <div style={{ maxWidth: '100%', backgroundColor: '#f3edf8', padding: '12px' }}>
            <div style={{ backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 12px rgba(107,76,122,0.10)', overflow: 'hidden' }}>
                {loading && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(107, 76, 122, 0.18)', backdropFilter: 'blur(3px)',
                        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                    }}>
                        <div style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
                            backgroundColor: 'white', borderRadius: '12px', padding: '24px 40px',
                            boxShadow: '0 8px 32px rgba(107,76,122,0.18)'
                        }}>
                            <CircularProgress style={{ color: '#6b4c7a' }} size={36} thickness={4} />
                            <span style={{ color: '#6b4c7a', fontSize: '13px', fontWeight: 600 }}>Loading...</span>
                        </div>
                    </div>
                )}

                {/* ── Header Bar ── */}
                <div style={{
                    background: 'linear-gradient(135deg, #6b4c7a 0%, #9b6dac 100%)',
                    padding: '10px 16px',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: 'white', letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                            📋 Additional Order List
                        </h2>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {hasCreateMasterPermission && (
                            <Link to={`/AdditionalOrderCreate/${id}`} style={{ textDecoration: 'none' }}>
                                <Button variant="contained" style={{
                                    height: '32px', fontSize: '11px', fontWeight: 700,
                                    backgroundColor: '#10a37f', color: 'white',
                                    borderRadius: '16px', textTransform: 'none',
                                    boxShadow: '0 2px 6px rgba(16,163,127,0.4)',
                                    padding: '0 14px',
                                }}>
                                    <AddIcon style={{ fontSize: '16px', marginRight: '4px' }} />
                                    Create
                                </Button>
                            </Link>
                        )}
                        <Tooltip title="Back">
                            <Link to={`/TriporderedIndexs/${id}`} style={{ textDecoration: 'none' }}>
                                <Button variant="contained" style={{
                                    height: '32px', fontSize: '11px', fontWeight: 700,
                                    backgroundColor: 'rgba(255,255,255,0.15)', color: 'white',
                                    borderRadius: '16px', textTransform: 'none',
                                    border: '1px solid rgba(255,255,255,0.4)', boxShadow: 'none',
                                    padding: '0 12px',
                                }}>
                                    Back <ExitToAppIcon style={{ marginLeft: '3px', fontSize: '14px' }} />
                                </Button>
                            </Link>
                        </Tooltip>
                    </div>
                </div>

                {/* ── Table Section ── */}
                <div style={{ padding: '10px 14px' }}>
                    <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(107,76,122,0.12)', border: '1px solid #e0d6e8' }}>
                        <div style={{ overflowX: 'auto', maxHeight: '550px', overflowY: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                                    <tr style={{ backgroundColor: '#6b4c7a' }}>
                                        {[
                                            { label: '#', align: 'center', width: '4%' },
                                            { label: 'Customer Name', align: 'left', width: '30%' },
                                            { label: 'Contact Number', align: 'center', width: '15%' },
                                            { label: 'Trip Description', align: 'left', width: '20%' },
                                            { label: 'Route Name', align: 'left', width: '18%' },
                                            { label: 'Action', align: 'center', width: '13%' },
                                        ].map((col, i) => (
                                            <th key={i} style={{
                                                color: 'white', fontWeight: 700, fontSize: '11px',
                                                padding: '10px 8px', textAlign: col.align, width: col.width,
                                                whiteSpace: 'nowrap',
                                                borderRight: i < 5 ? '1px solid rgba(255,255,255,0.18)' : 'none',
                                                letterSpacing: '0.3px',
                                            }}>
                                                {col.label}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.length > 0 ? (
                                        data.map((item, index) => {
                                            const rowBg = index % 2 === 0 ? '#faf8fc' : '#ffffff';
                                            return (
                                                <tr key={item.id}
                                                    style={{ backgroundColor: rowBg, borderBottom: '1px solid #ede7f3', transition: 'background 0.15s' }}
                                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3edf8'}
                                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = rowBg}
                                                >
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#6b4c7a', fontWeight: 700, borderRight: '1px solid #ede7f3' }}>
                                                        {index + 1}
                                                    </td>
                                                    <td style={{ fontSize: '12px', padding: '8px', fontWeight: 600, color: '#3d2459', borderRight: '1px solid #ede7f3' }}>
                                                        {item.customerName} {item.addressLine1}
                                                    </td>
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#555', borderRight: '1px solid #ede7f3' }}>
                                                        {item.phone}
                                                    </td>
                                                    <td style={{ fontSize: '11px', padding: '8px', color: '#333', borderRight: '1px solid #ede7f3' }}>
                                                        {item.tripdetails}
                                                    </td>
                                                    <td style={{ fontSize: '11px', padding: '8px', color: '#333', borderRight: '1px solid #ede7f3' }}>
                                                        <span style={{ display: 'inline-block', background: '#ede7f3', borderRadius: '10px', padding: '2px 10px', fontWeight: 600, fontSize: '10px' }}>
                                                            {item.rName}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '11px', padding: '6px', textAlign: 'center' }}>
                                                        {hasEditMasterPermission && (
                                                            <Link to={`/AdditionalOrderEdit/${item.id}`}>
                                                                <Tooltip title="Edit">
                                                                    <IconButton size="small" style={{ padding: '4px', backgroundColor: '#f3edf8', borderRadius: '6px', marginRight: '4px' }}>
                                                                        <EditIcon style={{ color: '#6b4c7a', fontSize: '16px' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Link>
                                                        )}
                                                        {hasDeleteMasterPermission && (
                                                            <Tooltip title="Delete">
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => openDeleteDialog(item.id, `${item.customerName} ${item.addressLine1}`)}
                                                                    style={{ padding: '4px', backgroundColor: '#fdecea', borderRadius: '6px' }}
                                                                >
                                                                    <DeleteIcon style={{ color: '#e53935', fontSize: '16px' }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: 'center', padding: '40px', color: '#aaa', fontSize: '13px', fontStyle: 'italic' }}>
                                                No additional orders found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Delete Confirm Dialog */}
                <Dialog
                    open={confirmDialogOpen}
                    onClose={closeDeleteDialog}
                    PaperProps={{ style: { borderRadius: '12px', padding: '8px', minWidth: '340px' } }}
                >
                    <DialogTitle style={{ color: '#6b4c7a', fontWeight: 700, fontSize: '16px' }}>
                        Delete Order?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ fontSize: '13px', color: '#444' }}>
                            ⚠️ Are you sure you want to delete the order for <strong>"{deleteItemName}"</strong>? This cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: '8px 16px 16px', gap: '8px' }}>
                        <button
                            onClick={closeDeleteDialog}
                            style={{ backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleDelete}
                            style={{ backgroundColor: '#e53935', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}
                        >
                            Delete
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}

export default AddtionalOrderIndex;
